<div class="modal-body modal-no-title">
  <button type="button" class="close" aria-label="Close" (click)="close(true)">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
  <h3 [innerHTML]="'academy.Partner_offer_modal_title'|translate"></h3>
  <div class="text-center">
    <a href="" [routerLink]="'/partner-offer/'"  (click)="close(false)" class="button button-orange" data-dismiss="modal">{{ 'company_profile.More_info'|translate }}</a>
  </div>
</div>
